module.exports = __webpack_public_path__ + "img/myposition_wb_마르셀루.60bbdd4a.png";